import { PropertyFilterProps } from "@amzn/awsui-components-react/polaris";

export const dateFieldNames = [
  "statute_of_limitations",
  "actualDueDate",
  "closeDate",
  "noticeDate",
  "filingDate",
  "auditStartDate",
  "auditEndDate",
  "auditInitiationDate",
  "auditCloseDate",
  "progressModifiedAt",
  "progress_modified_at",
  "ResponseDeadline",
  "taxPeriodStart",
  "taxPeriodEnd",
  "taxPeriodStartDate",
  "taxPeriodEndDate",
  "audit_initiation_date",
  "date_received",
  "initiationDate",
  "initialFilingDate",
  "statuteOfLimitations",
  "closedDate",
  "created_at",
  "modified_at",
  "notify_at",
  "reopened_at",
];

export const statusUpdateFields = [
  "status",
  "progress_modified_by",
  "progress_modified_at",
  "progressModifiedBy",
  "progressModifiedAt",
  "status_action_owner",
  "statusActionOwner",
  "statusDetail",
  "effort",
];

export const customAttributeFieldNames = [
  "customAttributesDataMap",
  "custom_attributes_data_map",
];

// List of fields to not display in the UI
export const filterFieldsList = [
  "modified_at",
  "modified_by",
  "resource_id",
  "edge",
  "audit_name_suffix",
  "team_name",
  "templateIdList",
  "jurisdiction_level",
  "order",
];

export interface IActivityLogProps {
  parentId: string;
  taskId?: string;
  // Team settings view: team record rows keep only changes the team can make itself.
  teamLevelChangesOnly?: boolean;
}

export interface FilterOption {
  label: string;
  value: string;
}

export interface ChangeLog {
  attributeName: string;
  oldValue: string;
  newValue: string;
}

export interface ActivityItem {
  objectId: string;
  operation: string;
  user: string;
  timestamp: string;
  resourceId: string;
  edge: string;
  category: string;
  objectName: string;
  headerDate: string;
  changeLogs: ChangeLog[];
}

export interface ListActivityLogsInput {
  parentId: string;
  taskId?: string;
}

export interface ListActivityLogsOutput {
  activities: ActivityItem[];
  // Never read as "more rows exist": `ListActivityLogsInput` carries no
  // cursor, so no "load more" affordance can be driven from this field.
  truncated?: boolean;
}

export interface ActivityPreferences {
  pageSize: number;
  wrapLines: boolean;
  stripedRows: boolean;
  contentDisplay: Array<{ id: string; visible: boolean }>;
}

export const propertyFilterI18nStrings: PropertyFilterProps.I18nStrings = {
  filteringPlaceholder: "Find activities",
  groupValuesText: "Values",
  groupPropertiesText: "Properties",
  operatorsText: "Operators",
  operatorText: "Operator",
  clearFiltersText: "Clear filters",
  removeTokenButtonAriaLabel: (token: any) =>
    `Remove token ${token.propertyKey} ${token.operator} ${token.value}`,
  enteredTextLabel: (text: string) => `Use: "${text}"`,
};
